import { RegressionModelDetails } from "@/components/RegressionModelDetails";
import { Alert, AlertDescription } from "@/components/ui/alert";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import RegressionModel from "@/types/RegressionModel";
import { Info } from "lucide-react";

type TrendMethodSelectorProps = {
  regressionModel: RegressionModel | null;
  onModelChange: (model: RegressionModel) => Promise<void>;
};

export function TrendMethodSelector({ regressionModel, onModelChange }: TrendMethodSelectorProps) {
  return (
    <div className="space-y-4">
      <div className="font-bold pt-4">Select a trend method</div>
      <Select
        defaultValue={(regressionModel as string) || undefined}
        onValueChange={async (v) => {
          await onModelChange(v as RegressionModel);
        }}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select an algorithm" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value={RegressionModel.Loess}>
              Locally weighted regression (recommended)
            </SelectItem>
            <SelectItem value={RegressionModel.Linear}>Linear</SelectItem>
          </SelectGroup>
        </SelectContent>
      </Select>

      {regressionModel === RegressionModel.Loess && (
        <div className="pt-2">
          <Alert>
            <Info className="h-4 w-4" />
            <AlertDescription>
              <RegressionModelDetails model={RegressionModel.Loess} />
            </AlertDescription>
          </Alert>
        </div>
      )}

      {regressionModel === RegressionModel.Linear && (
        <div className="pt-2">
          <Alert>
            <Info className="h-4 w-4" />
            <AlertDescription>
              <RegressionModelDetails model={RegressionModel.Linear} />
            </AlertDescription>
          </Alert>
        </div>
      )}
    </div>
  );
}
